import {LanguageButton, type LanguageButtonVariant} from '@chekinapp/ui';
import {useTranslation} from 'react-i18next';
import {ChevronDown} from 'lucide-react';
import {useCurrentLanguage} from 'hooks/useCurrentLanguage';
import {useLanguageModalStore} from 'components/LanguageModal';

type Props = {
  variant?: LanguageButtonVariant;
  display?: 'code' | 'name' | 'word';
  withFlag?: boolean;
  withChevron?: boolean;
  className?: string;
};

function LocaleButton({
  variant = 'outline',
  display = 'name',
  withFlag = false,
  withChevron = false,
  className,
}: Props) {
  const {t} = useTranslation();
  const config = useCurrentLanguage();
  const openLanguageModal = useLanguageModalStore(state => state.open);

  const label =
    display === 'code'
      ? config?.value?.split('-')[0].toUpperCase()
      : display === 'word'
      ? t('language')
      : config?.label;

  return (
    <LanguageButton
      variant={variant}
      label={
        withChevron ? (
          <>
            {label}
            <ChevronDown size={14} className="opacity-80" />
          </>
        ) : (
          label
        )
      }
      flagSrc={withFlag ? config?.flag : undefined}
      onClick={openLanguageModal}
      aria-label={t('language')}
      className={className}
    />
  );
}

export {LocaleButton};
